import { writable } from 'svelte/store';
import { PROFILE_REMINDER } from './lib/constants';
import { getCookie } from './utils';

export const isShowingHelpModal = writable(false);
export const isShowingLogOutModal = writable(false);
export const createProfileModalOpen = writable(false);
export const createProfileModalTitle = writable(
  "We've added Account Profiles.",
);
export const createProfileModalInnerText = writable(
  'Complete your profile to personalize your PostTap experience.',
);
export const openCreateProfileModal = () => {
  // Open the create profile form if applicable
  const remindMeCookie = getCookie(PROFILE_REMINDER);
  if (remindMeCookie) {
    const remindMeTimestamp = remindMeCookie;
    const weekAgo = new Date();
    // remind after 7 days
    weekAgo.setDate(weekAgo.getDate() - 7);
    if (remindMeTimestamp < weekAgo.getTime()) {
      createProfileModalOpen.set(true);
    }
  } else {
    createProfileModalOpen.set(true);
  }
};

export const toasts = writable([]);

export const dismissToast = (id) => {
  toasts.update((all) => all.filter((t) => t.id !== id));
};

export const addToast = (toast) => {
  // Create a unique ID so we can easily find/remove it
  // if it is dismissible/has a timeout.
  const id = Math.floor(Math.random() * 10000);

  // Setup some sensible defaults for a toast.
  const defaults = {
    id,
    type: 'info',
    dismissible: true,
  };
  const freshToast = { ...defaults, ...toast };

  // Push the toast to the top of the list of toasts
  toasts.update((all) => [freshToast, ...all]);

  // If toast is dismissible, dismiss it after "timeout" amount of time.
  if (toast.timeout) {
    setTimeout(() => {
      dismissToast(id);
    }, toast.timeout);
  }
};

// Function to read the current URL's query parameters and return an object
function readFromURL() {
  const params = new URLSearchParams(window.location.search);
  const stateFromURL = {};

  for (const [key, value] of params.entries()) {
    // Deserialize values as needed
    stateFromURL[key] = value;
  }

  return stateFromURL;
}

// Initial state from URL
const initialState = readFromURL();

// Creating the writable store
export const searchParams = writable(initialState);

// Function to update the URL's query parameters based on the store's state
function writeToURL(state) {
  const params = new URLSearchParams();

  for (const key in state) {
    if (state[key] && Object.prototype.hasOwnProperty.call(state, key)) {
      // Serialize values as needed
      params.set(key, state[key]);
    }
  }

  window.history.pushState({}, '', `${window.location.pathname}?${params}`);
}

// Subscribe to the store and update the URL when it changes
searchParams.subscribe((state) => {
  writeToURL(state);
});

// Listen for changes in the URL
window.onpopstate = () => {
  searchParams.set(readFromURL());
};
